import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { BsModalService } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';
import { AuthService } from '../api-services/Auth/auth.service';
import { keyService } from '../api-services/keycloak/service/key.service';
import { PreviousRouterService } from '../api-services/previous-route/previous-router.service';
/**
 * This login component using for user logged-in and sign up.
 * For logged-in using keycloak third party package.
 * It's handle user management like roles ,session tokens..etc.
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  public loggedIn: any = false;
  loggedUser: any;
  emailRegx = new RegExp('^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,3}$');
  public userProfile: KeycloakProfile = {};
  @ViewChild('msg') modalRef;
  loginForm: FormGroup;
  
  registerForm: FormGroup = new FormGroup(
    {
      firstname: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(35),
        Validators.pattern("^[a-zA-Z -']+"),
      ]),
      lastname: new FormControl('', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(35),
        Validators.pattern("^[a-zA-Z -']+"),
      ]),
      email: new FormControl('', [Validators.required, Validators.email]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
      ]),
      confirmPassword: new FormControl('', [
        Validators.required,
        Validators.minLength(8),
      ]),
    },
    {
      validators: (control) => {
        if (control.value.password !== control.value.confirmPassword) {
          control.get('confirmPassword').setErrors({ notSame: true });
        }
        return null;
      },
    }
  );
  loader = false;
  previousUrl;
  @ViewChild('signIn') signInTab: ElementRef;
  @ViewChild('signup') signUpTab: ElementRef;
  message: any;
  role: string[];
  redirectUrl: any;
  formErrors: any = {
    firstname: '',
    lastname: '',
    email: '',
    password: '',
    confirmPassword: '',
  };
  getReq: any;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private modalService: BsModalService,
    private urlService: PreviousRouterService,
    private kc: KeycloakService,
    private changeDect: ChangeDetectorRef,
    private keycloak: keyService
  ) {}

  async ngOnInit() {
    this.loggedIn = await this.keycloak.isLoggedIn();
    if (this.loggedIn) {
      this.role = this.keycloak.getRoles();//console.log("this.role",this.role);
      this.roleBased_nav();
    }
    this.redirectUrl = this.route.snapshot.queryParams['redirectTo'];
    const register_nav = this.route.snapshot.queryParams['signup'];
    if (register_nav == '') {
      let ele = document.getElementById('register');
      if (ele) {
        ele.click();
      }
    }

    //get previous router Navgiations
    this.urlService.previousUrl$.subscribe((previousUrl$: string) => {
      this.previousUrl = previousUrl$;
    });
  }

  keycloak_login() {
    this.keycloak.login();
  }
  /**
   * This method to check user email id exit or not  while registration
   */
  emailValidation() {
    this.changeDect.detectChanges();
    if (this.emailRegx.test(this.registerForm.get('email').value)) {
      let emailReq = {
        email: this.registerForm.get('email').value,
      };
      this.authService.check_userValid(emailReq).subscribe(
        (res: any) => {
          this.getReq = res;
        },
        (err) => {
          if (err.status == '409') {
            this.getReq = err.error;
            this.registerForm.get('email').setErrors({ exist: true });
            this.registerForm.get('email').updateValueAndValidity;
            this.changeDect.detectChanges();
          }
        }
      );
    }
  }

  /**
   * This method for to regitration a member/user.
   * To filling input the first and last name ,email and password.
   * @returns This return for checking  user validatation
   */
  sendRegistrationDetails() {
    if (!this.registerForm.valid) {
      return this.registerForm.markAllAsTouched();
    } else {
      this.authService.ayurwaySignUp(this.registerForm.value).subscribe(
        (signUpData: any) => {
          if (signUpData) {
            this.modalService.show(this.modalRef, {
              backdrop: 'static',
              keyboard: false,
              initialState: {
                message:
                  'Sign-up has been successfully completed.Please check your email for active your account.',
              },
            });
            this.registerForm.reset();
          }
        },
        (err) => {
          // this.loader = true;

          if (err.status === 400) {
            for (let [key, value] of Object.entries(err.error.data)) {
              this.formErrors[key] = value;
            }
          }
        }
      );
    }
  }
  modalClose() {
    this.modalService.config.initialState = '';
    this.modalService.hide();
    document.getElementById('signIn').click();
  }

  /**
   *This method to navigate route based on logged in role bases
   */
  roleBased_nav() {
    if (this.role.includes('AyurwayAdmin')) {
      this.router.navigate(['/admin/all-appointmentlist']);
    } else if (this.role.includes('member')) {
      this.router.navigate(['/talktodoctor']);
    } else if (this.role.includes('doctor')) {
      this.router.navigate(['/doctorappoinment-list']);
    }
     else if (this.previousUrl == '/wellness') {
      this.router.navigate(['/home']);
    } else if (this.previousUrl) {
      this.router.navigateByUrl(this.previousUrl);
    } else {
      this.router.navigate(['/home']);
    }
  }
}
